import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-[#3A7D78] mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">抱歉，您访问的页面不存在</p>
        <Link 
          to="/" 
          className="bg-[#3A7D78] text-white px-6 py-2 rounded-full hover:bg-[#F5B6C1] transition-colors"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
};

export default NotFound;